// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__vsskq","errorLogs":"EditorFooter_errorLogs__31nX6"};